<template>
    <v-app>
        <router-view></router-view>
    </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";

export default {
  name: "App",
  components: {
    // HelloWorld
  },
  created() {

  }

};
</script>

<style>
    @font-face {
        font-family: sy-HanSansCN-Noraml;
        src: url('assets/family/SourceHanSansCN-Normal.ttf');
    }

    @font-face {
        font-family: Montserrat;
        src: url('assets/family/Montserrat-Light-6.otf');
    }

    html {
        width: 100%;
        height: 100%;
        overflow-y: hidden !important;
    }

    body {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 960px) {
        .v-application {
            height: 100%;
        }
    }

    .v-application{
        width: 100%;
        height: 100%;
    }

</style>
